import { markRaw } from 'vue'

import ChartBarIcon from 'vue-material-design-icons/ChartBar.vue'
import ImageMultipleOutlineIcon from 'vue-material-design-icons/ImageMultipleOutline.vue'
import AccountDetailsIcon from 'vue-material-design-icons/AccountDetails.vue'
import UploadCircleOutlineIcon from 'vue-material-design-icons/UploadCircleOutline.vue'
import ApplicationIcon from 'vue-material-design-icons/Application.vue'
import ListBoxIcon from 'vue-material-design-icons/ListBox.vue'
import FolderMultipleImageIcon from 'vue-material-design-icons/FolderMultipleImage.vue'
import FolderOutlineIcon from 'vue-material-design-icons/FolderOutline.vue'
import PlaylistStarIcon from 'vue-material-design-icons/PlaylistStar.vue'
import TuneVerticalIcon from 'vue-material-design-icons/TuneVertical.vue'
import CogIcon from 'vue-material-design-icons/Cog.vue'
import MultimediaIcon from 'vue-material-design-icons/Multimedia.vue'
import UploadMultipleOutlineIcon from 'vue-material-design-icons/UploadMultipleOutline.vue'
import FormDropdownIcon from 'vue-material-design-icons/FormDropdown.vue'
import MessageCogIcon from 'vue-material-design-icons/MessageCog.vue'
import CogSyncOutlineIcon from 'vue-material-design-icons/CogSyncOutline.vue'
import SendIcon from 'vue-material-design-icons/Send.vue'
import DotsHorizontalIcon from 'vue-material-design-icons/DotsHorizontal.vue'
import ChartBoxOutlineIcon from 'vue-material-design-icons/ChartBoxOutline.vue'
import ClipboardTextSearchOutlineIcon from 'vue-material-design-icons/ClipboardTextSearchOutline.vue'
import ShieldCheckOutlineIcon from 'vue-material-design-icons/ShieldCheckOutline.vue'
import StarCircleOutlineIcon from 'vue-material-design-icons/StarCircleOutline.vue'
import FileChartOutlineIcon from 'vue-material-design-icons/FileChartOutline.vue'
import CheckDecagramOutlineIcon from 'vue-material-design-icons/CheckDecagramOutline.vue'
import RssIcon from 'vue-material-design-icons/Rss.vue'
import WidgetsOutlineIcon from 'vue-material-design-icons/WidgetsOutline.vue'
import TrophyOutlineIcon from 'vue-material-design-icons/TrophyOutline.vue'
import LockOutlineIcon from 'vue-material-design-icons/LockOutline.vue'
import DatabaseCogOutlineIcon from 'vue-material-design-icons/DatabaseCogOutline.vue'
import BrainIcon from 'vue-material-design-icons/Brain.vue'

export const menuItems = [
	{
		label: "Dashboard",
		link: "/home",
		icon: markRaw(ChartBarIcon),
	},
	{
		label: "Media",
		link: "/media",
		icon: markRaw(ImageMultipleOutlineIcon),
	},
	{
		label: "Members",
		link: "/members",
		icon: markRaw(AccountDetailsIcon),
	},
	{
		label: "Upload",
		link: "/upload",
		icon: markRaw(UploadCircleOutlineIcon),
	},
	{
		label: "Applications",
		link: "/applications",
		icon: markRaw(ApplicationIcon),
	},
	{
		label: "Organize",
		icon: markRaw(ListBoxIcon),
		children: [
			{ label: "Groups", link: "/groups", icon: markRaw(FolderMultipleImageIcon) },
			{ label: "Channels", link: "/channels", icon: markRaw(FolderOutlineIcon) },
			{ label: "Collections", link: "/collections", icon: markRaw(PlaylistStarIcon) },
		],
	},
	{
		label: "Engage",
		icon: markRaw(StarCircleOutlineIcon),
		children: [
			{ label: "Widgets", link: "/widgets", icon: markRaw(WidgetsOutlineIcon) },
			{ label: "Gamification", link: "/gamification", icon: markRaw(TrophyOutlineIcon) },
			{ label: "Validation", link: "/validation", icon: markRaw(CheckDecagramOutlineIcon) },
		],
	},
	{
		label: "Reports",
		icon: markRaw(FileChartOutlineIcon),
		children: [
			{ label: "Analytics", link: "/reports", icon: markRaw(ChartBoxOutlineIcon) },
			{ label: "Audit Log", link: "/audit-log", icon: markRaw(ClipboardTextSearchOutlineIcon) },
		],
	},
	{
		label: "Settings",
		icon: markRaw(TuneVerticalIcon),
		children: [
			{ label: "General", link: "/settings/general", icon: markRaw(CogIcon) },
			{ label: "Media", link: "/settings/media", icon: markRaw(MultimediaIcon) },
			{ label: "Uploader", link: "/settings/uploader", icon: markRaw(UploadMultipleOutlineIcon) },
			{ label: "Meta Data", link: "/settings/metadata", icon: markRaw(FormDropdownIcon) },
			{ label: "Metadata Config", link: "/metadata-config", icon: markRaw(DatabaseCogOutlineIcon) },
			{ label: "Notifications", link: "/notifications", icon: markRaw(MessageCogIcon) },
			{ label: "AI Interface", link: "/settings/ai", icon: markRaw(ShieldCheckOutlineIcon) },
			{ label: "Permissions", link: "/permissions", icon: markRaw(LockOutlineIcon) },
		],
	},
	{
		label: "Advanced",
		icon: markRaw(DotsHorizontalIcon),
		children: [
			{ label: "ML Training", link: "/ml-training", icon: markRaw(BrainIcon) },
			{ label: "Converter Queue", link: "/converter-queue", icon: markRaw(CogSyncOutlineIcon) },
			{ label: "Transfers", link: "/transfers", icon: markRaw(SendIcon) },
			{ label: "Feeds", link: "/feeds", icon: markRaw(RssIcon) },
		],
	},
]

export default menuItems
